<template>
    <div>
        <div data-testid="info-session-option" class="btn info-course-button text-start ps-5 p-3 mb-3">Sorry, {{dayFormat}} at {{startTimeFormat}} - {{endTimeFormat}} is fully booked</div>
    </div>
</template>

<script setup>
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { computed } from 'vue';

const props = defineProps({
    startDate: String,
    startTime: String,
    endTime: String
})

let dayFormat = computed(() => {
    return format(new Date(props.startDate), 'EEEE do LLLL yyyy')
})
let startTimeFormat = computed(() => {
    return format(parse(props.startTime, 'HH:mm', new Date()), 'h:mm a')
})
let endTimeFormat = computed(() => {
    return format(parse(props.endTime, 'HH:mm', new Date()), 'h:mm a')
})
</script>

<style scoped>
.info-course-button {
    font-weight: 500;
    width:100%;
    box-shadow: 4px 5px 22px 7px rgba(158,158,158,0.21);
    text-decoration: none;
    background: white;
}

.selected {
    color:white;
    background: #007ab3;
}

@media (min-width: 768px) {
    .info-course-button {
        width: 38rem !important;
    }
}

</style>
